import axios from 'axios';
import { isProd } from '../utils/constants';
import {
  getAccessToken,
  getRefreshToken,
  clearTokens,
  setTokens
} from '../utils';
import { getNewTokenPair } from '../api/auth';

export const axiosInstance = axios.create({
  baseURL: `${
    isProd
      ? process.env.REACT_APP_API_BASE_URL_PROD
      : process.env.REACT_APP_API_BASE_URL_DEV
  }`,
  headers: {
    'Content-Type': 'application/json'
  }
});

let isRefreshing = false;
let failedRequestsQueue: any[] = [];

async function updateAccessToken() {
  const refresh_token = getRefreshToken();

  if (refresh_token) {
    isRefreshing = true;
    try {
      const data = await getNewTokenPair(refresh_token);
      // @ts-ignore
      if (data.response && data.response.status === 401) {
        isRefreshing = false;
        alert('Invalid refresh token');
        clearTokens();
        window.location.href = '/admin/87431/login';
        return;
      }

      setTokens(data);

      failedRequestsQueue.forEach((cb) => cb());
      failedRequestsQueue = [];
    } catch (error) {
      console.error('Failed to refresh token:', error);
      clearTokens();
      window.location.href = '/admin/87431/login';
    } finally {
      isRefreshing = false;
    }
  } else {
    isRefreshing = false;
    clearTokens();
    window.location.href = '/admin/87431/login';
  }
}

const addAuthorizationHeader = (config: any) => {

  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();

  if (config.url.includes('/auth/token') && refreshToken) {
    config.headers['Authorization'] = `Bearer ${refreshToken}`;
  } else if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  return config;
};

axiosInstance.interceptors.request.use(addAuthorizationHeader, (error) =>
  Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config: originalRequest } = error;

    if (!response) throw error;

    const shouldRetry = 
      response.status === 401 && !originalRequest.url.includes('/auth/token');

    if (shouldRetry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedRequestsQueue.push(() => {
            originalRequest.headers['Authorization'] = `Bearer ${getAccessToken()}`;
            axiosInstance(originalRequest).then(resolve).catch(reject);
          });
        });
      }

      try {
        await updateAccessToken();

        originalRequest.headers['Authorization'] = `Bearer ${getAccessToken()}`;
        return axiosInstance(originalRequest);
      } catch (error) {
        return Promise.reject(error);
      }
    }

    throw error;
  }
);

export default axiosInstance;
